import { render, staticRenderFns } from "./addHighSetting.vue?vue&type=template&id=5256d446&scoped=true&"
import script from "./addHighSetting.vue?vue&type=script&lang=js&"
export * from "./addHighSetting.vue?vue&type=script&lang=js&"
import style0 from "./addHighSetting.vue?vue&type=style&index=0&id=5256d446&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5256d446",
  null
  
)

export default component.exports